import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import '../../css/listing.css';
import Dashboard from "./Dashboard";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Handler } from "leaflet";
import { Convertimageurl } from "./Convertimageurl";

const Listings = ({ agent_id }) => {
    const navigate = useNavigate();
    const [listings, setListings] = useState([]);

    const [agentId, setAgentId] = useState(() => {
        return agent_id || localStorage.getItem("agent_id") || sessionStorage.getItem("agent_id");
    });

    useEffect(() => {
        if (!agentId) {
            console.warn("❌ No agent_id found, redirecting to login...");
            navigate("/");
            return;
        }

        sessionStorage.setItem("agent_id", agentId);
        fetchListings();
    }, [navigate, agentId]);

    const fetchListings = async () => {
        if (!agentId) {
            console.error("❌ No agent_id found, aborting fetch.");
            return;
        }

        try {
            console.log(`🔍 Fetching listings for agent_id: ${agentId}`);
            const response = await axios.get(`/api/agent/listings/${agentId}`);

            if (!response.data || response.data.length === 0) {
                console.warn("⚠️ No listings found for this agent.");
            } else {
                console.log("✅ Listings received:", response.data);
            }

            setListings(response.data);
        } catch (error) {
            console.error("❌ Error fetching listings:", error.response?.data || error.message);
        }
    };

    const handleEdit = (property) => {
        alert("Edit property: " + property.bpn);
        let editPath = '';

        if (property.proptype === 'Residential' && property.lookingto === 'Rent') {
            editPath = '/residential-rent';
        } else if (property.proptype === 'Residential' && property.lookingto === 'Resale') {
            editPath = '/residential-resell';
        } else if (property.proptype === 'Residential' && property.lookingto === 'PG/Co-living') {
            editPath = '/pg-co-living';
        } else if (property.proptype === 'Commercial' && property.lookingto === 'Rent') {
            editPath = '/Commercial-rent';
        } else if (property.proptype === 'Commercial' && property.lookingto === 'Resale') {
            editPath = '/Commercial-resale';
        } else {
            return;
        }

        navigate(editPath, { state: { property } });
    };

    const handleDeactivate = async (propertyId) => {
        try {
            const confirmed = window.confirm("Are you sure you want to deactivate this property?");
            if (!confirmed) return;
    
            const response = await axios.put(`/api/agent/listings/update-status/${propertyId}`, {
                status: 'd'
            });
    
            console.log("✅ Property deactivated:", response.data);
    
            toast.success("Property Deactivated Successfully ✅", {
                position: "top-center",
                autoClose: 2000,
            });
    
            // Refresh listings after update
            fetchListings();
        } catch (error) {
            console.error("❌ Error deactivating property:", error.response?.data || error.message);
            toast.error("Failed to deactivate property ❌", {
                position: "top-center",
                autoClose: 3000,
            });
        }
    };
    
    

    return (
        <div>
            <Dashboard />
            <ToastContainer />
            <div className="listing-container">

                {listings.length > 0 ? (
                    listings.map((listing) => (
                        <div key={listing.id} className="listing-card">

                            {/* Render Multiple Images */}
                            <div className="image-gallery">
                                <img
                                    src={listing.images[0]}
                                    alt="Property"
                                    style={{ width: "300px", height: "200px", objectFit: "cover" }}
                                />
                            </div>
                            <div>
                                <h3>{listing.bpn} - {listing.pinlocality || listing.locality}</h3>
                                <h3> {listing.proptype || listing.proptype} </h3>
                                <h3> {listing.lookingto} </h3>
                                <p>Property Type: {listing.proptypename}</p>
                                <p>price: ₹{listing.monthlyrent || listing.cost}</p>
                                <p>City: {listing.city}</p>
                                <p>Status: {listing.status === 'a' ? "ON Moving ✅" : "Pending ⏳"}</p>
                            </div>


                            {/* Edit & Approval Buttons */}
                            <div className="actions">
                                <button className="edit-btn" onClick={() => handleEdit(listing)}>Edit 📝</button>
                                <button className="approve-btn" onClick={() => handleDeactivate(listing.postid)}>Deactivate 🗑️ </button>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="no-listings">
                    <div className="side">    <div className="ribbon-text">  No Listings • No Listings • No Listings • </div></div>
                    <div className="side1">     <div className="ribbon-text">  Add Property • Add Property • Add Property •</div></div>
                    <div class="sad-box"></div>
                    <h2>No Listings Yet</h2>
                    <p>You haven’t added any properties. Let’s fix that!</p>
                  
                </div>
                )}
            </div>
          {/* <Convertimageurl /> */}

        </div>
    );
};

export default Listings;
